import { render, staticRenderFns } from "./AddStory.vue?vue&type=template&id=44b87dbc&scoped=true&"
import script from "./AddStory.vue?vue&type=script&lang=js&"
export * from "./AddStory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b87dbc",
  null
  
)

export default component.exports